import { React, useEffect } from "react";
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
import "./Info.scss"


export const Privacity = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    return (
        <div className="info-pages">
            <div className="modal-content-info bg-white shadow">
            <div className="row text-end pe-4 me-3 pt-2">
                <Link to="/score">
                    <Button className="col position-fixed">
                        <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
                        </svg></span>
                    </Button>
                </Link>
            </div>
                <div className="text-legal">

                    <h1 className="text-start mb-4">
                        Política de privacidad
                    </h1>
                    <p>
                        En SOLUNION nos comprometemos a asegurar que su información personal se
                        encuentre protegida y no se utilice de forma indebida.
                    </p>
                    <p>
                        En este documento explicamos quién es el responsable de tratamiento, con
                        qué finalidad se va a tratar su información personal, la legitimación para
                        el tratamiento, cómo la recabamos, por qué la recabamos, cómo la
                        utilizamos, los derechos que le asisten y también se explican los procesos
                        que hemos dispuesto para proteger su privacidad.
                    </p>
                    <p>
                        Al facilitarnos su información personal y utilizar nuestros sitios web para
                        ordenador y tablet, entendemos que ha leído y comprendido los términos
                        relacionados con la información de protección de datos de carácter personal
                        que se exponen. SOLUNION asume la responsabilidad de cumplir con la
                        legislación vigente en materia de protección de datos nacional y europea, y
                        tiene el objetivo de tratar sus datos de manera lícita, leal y
                        transparente.
                    </p>
                    <p>
                        <strong>ÁMBITO DE APLICACIÓN</strong>
                    </p>
                    <p>
                        El presente documento es de aplicación a todas las empresas del Grupo
                        SOLUNION, para los usuarios Clientes de SOLUNION, con el tipo y alcance del
                        tratamiento de datos que acto seguido se determina.
                    </p>
                    <p>
                        Cliente: cuyo alcance al acceder a la plataforma online es la visualización
                        de cualquier aspecto relacionado con el servicio egrade contratado, entre
                        otros, sus condiciones económicas, así como cargos y abonos en relación al
                        servicio suscrito con SOLUNION, y la realización de gestiones del servicio
                        egrade.
                    </p>
                    <p>
                        Así mismo, la forma de acceso del usuario Cliente previamente identificado
                        tendrá el alcance que acto seguido se detalla:
                    </p>
                    <p>
                        Acceso vía ordenador y tablet: cuya funcionalidad es (i) consultiva: siendo
                        el alcance al acceder a través de ordenador y tablet, la visualización de
                        cualquier aspecto relacionado con el servicio egrade, entre otros, sus
                        condiciones económicas, los cargos y abonos en relación al servicio
                        contratado con SOLUNION, y (ii) de gestión: procediendo a la solicitud del
                        servicio egrade.
                    </p>
                    <p className="text-start">
                        <strong>CONSIDERACIÓN A TENER EN CUENTA</strong>
                    </p>
                    <p>
                        I. ¿Quién es responsable del tratamiento?
                    </p>
                    <p>
                        El responsable en el sentido del Reglamento General de Protección de Datos
                        de la UE, y de leyes de protección de datos nacionales de los Estados
                        miembros, unidas a otras disposiciones legales de protección de datos es:
                    </p>
                    <p>
                        Solunion Servicios de Crédito S.L. NIF: B/81419442 Dirección: Avenida
                        General Perón 40, 28020 Madrid
                    </p>
                    <p>
                        Esto significa que SOLUNION es la responsable de controlar los datos
                        personales que puede recopilar, y está obligada por ley a garantizar que se
                        implementen políticas, procesos y procedimientos para su salvaguarda.
                    </p>

                    <a target="_blank" rel="noreferrer" href="https://solunion.com/">www.solunion.es</a>
                    <p>
                        <a href="mailto:proteccion.dedatos.es@solunion.com">
                            proteccion.dedatos.es@solunion.com
                        </a>
                    </p>
                    <p>
                        II. ¿Qué tipo de información recogemos?
                    </p>
                    <p>
                        Los datos que nos proporciona y se recogen en este tratamiento, se refieren
                        a aquellos de personas naturales identificados e identificables. Siendo
                        parte de éstos, aquellos estrictamente necesarios, por ejemplo, cuando
                        acceda a nuestra web, el Usuario, a través de la dirección de correo
                        electrónico, contraseña, y en el caso meramente necesario deberá
                        proporcionar nombre y apellidos, número de teléfono, cargo, nombre de la
                        empresa, domicilio social de la empresa, y dirección IP.
                    </p>
                    <p>
                        Si visita nuestra plataforma accediendo vía web, recopilamos información
                        relativa a Ud. a través de las cookies. Una cookie es un pequeño fichero de
                        texto que se almacena en su navegador cuando visita casi cualquier
                        plataforma. Su utilidad es que la plataforma sea capaz de recordar su
                        visita cuando vuelva a navegar por esa página. Las cookies suelen almacenar
                        información de carácter técnico, preferencias personales, personalización
                        de contenidos, estadísticas de uso, enlaces a redes sociales, acceso a
                        cuentas de Usuario, etc. El objetivo de la cookie es adaptar el contenido
                        de la plataforma a su perfil y necesidades; sin cookies los servicios
                        ofrecidos por cualquier página se verían mermados notablemente. Si desea
                        consultar más información sobre qué son las cookies, qué almacenan, cómo
                        eliminarlas, desactivarlas, etc., le rogamos se dirija a este     <Link to="/cookies">enlace</Link>
                    </p>
                    <p>
                        III. ¿Con qué finalidad recabamos su información personal?
                    </p>
                    <p>
                        En SOLUNION trataremos los datos que nos suministre durante la navegación y
                        uso de nuestro sitio web, para las siguientes finalidades:
                    </p>
                    <p>
                        1. Respecto a la navegación y uso de nuestro sitio web, trataremos sus
                        datos para:
                    </p>
                    <p>
                        ·        Ofrecerle una navegación más personalizada y una mejor experiencia
                        como usuario de nuestro sitio web.
                    </p>
                    <p>
                        ·        Conocer la efectividad de los distintos botones y enlaces que
                        apuntan a nuestro servidor, con el fin de potenciar aquéllos que ofrezcan
                        mejores resultados.
                    </p>
                    <p>
                        ·        Mantener un registro de la actividad del usuario vía web.
                    </p>
                    <p>
                        ·        Gestionar nuestra actividad y el cumplimiento del propio servicio
                        contratado.
                    </p>
                    <p>
                        ·        Tarificar y tramitar las solicitudes de productos ofertados, a
                        través del presente sitio web.
                    </p>
                    <p>
                        ·        Cumplir con las obligaciones legales que nos resulten de
                        aplicación.
                    </p>
                    <ul>
                        <li>
                            Realizar estudios de control de calidad.
                        </li>
                    </ul>
                    <p>
                        ·        Tramitar, seguir, y actualizar cualquier solicitud de información,
                        relación negocial, precontractual o contractual, de cualquiera de las
                        distintas entidades del Grupo SOLUNION.
                    </p>
                    <p>
                        2. Respecto a los formularios de contacto y números de teléfono que hemos
                        puesto a su disposición en la presente plataforma, trataremos sus datos
                        para:
                    </p>
                    <p>
                        ·        Atender y gestionar las consultas y solicitudes que realice a
                        través de los números de teléfono facilitados a tal efecto.
                    </p>
                    <p>
                        ·        Atender y gestionar las sugerencias, reclamaciones y otras
                        consultas que realice a través del formulario correspondiente.
                    </p>
                    <p>
                        3. Igualmente, podremos emplearlos en cumplimiento de las obligaciones
                        legales para cumplir con las leyes aplicables, órdenes judiciales,
                        regulaciones gubernamentales o autoridades gubernamentales, cuando sea
                        necesario investigar, prevenir o tomar medidas con respecto a actividades
                        ilegales, sospecha de fraude, situaciones que involucren amenazas
                        potenciales para la seguridad de cualquier persona o violaciones de
                        nuestras políticas o términos.
                    </p>
                    <p>
                        IV. ¿Cuál es la legitimación para el tratamiento de la información
                        personal?
                    </p>
                    <p>
                        La base legal para el tratamiento de sus datos con las finalidades
                        indicadas es el consentimiento que nos haya otorgado para, entre otras
                        actividades, realizar acciones incluida la comunicación de sus datos a
                        otras empresas del Grupo SOLUNION. Dicho consentimiento quedará archivado
                        en la base de datos de cada Usuario, de tal forma podrá constatarse su
                        trazabilidad y evidencias.
                    </p>
                    <p>
                        Por otro lado, la base legal para el tratamiento de sus datos es la
                        ejecución del servicio egrade contratado; así como el cumplimiento de las
                        obligaciones legales que resulten de aplicación al Grupo SOLUNION.
                    </p>
                    <p>
                        Y, por último, el interés legítimo de SOLUNION en ofrecerle una opción de
                        consulta y gestión de su servicio contratado, con la facilidad de la
                        plataforma vía web, además de una navegación más personalizada.
                    </p>
                    <p>
                        V. ¿A quién podemos comunicar su información personal?
                    </p>
                    <p>
                        La información que nos facilita será comunicada a las empresas del Grupo
                        SOLUNION y Accionistas para tratarla con las finalidades descritas
                        anteriormente, así como terceros con los que suscriba acuerdos de
                        colaboración.
                    </p>
                    <p>
                        VI. Transferencia internacional
                    </p>
                    <p>
                        La información personal que recabamos reside en España, aunque es posible
                        que algunas empresas del Grupo tengan presencia en otros países y su
                        información personal se recabe en el país en el que reside.
                    </p>
                    <p>
                        VII. ¿Por cuánto tiempo almacenamos su información personal?
                    </p>
                    <p>
                        Solo almacenamos su información personal en la medida en que la necesitamos
                        a fin de poder utilizarla según la finalidad por la que fue recabada, y
                        según la base jurídica del tratamiento de la misma de conformidad con la
                        ley aplicable. Mantendremos su información personal mientras exista una
                        relación contractual y/o comercial con usted, o mientras usted no ejerza su
                        derecho de supresión, cancelación y/o limitación del tratamiento de sus
                        datos.
                    </p>
                    <p>
                        En estos casos, mantendremos la información debidamente bloqueada, sin
                        darle ningún uso, mientras pueda ser necesaria para el ejercicio o defensa
                        de reclamaciones o pueda derivarse algún tipo de responsabilidad judicial,
                        legal o contractual de su tratamiento, que deba ser atendida y para lo cual
                        sea necesaria su recuperación.
                    </p>
                    <p>
                        VIII. ¿Cómo protegemos su información personal?
                    </p>
                    <p>
                        Nos comprometemos a proteger su información personal y a tratar
                        confidencialmente su información personal salvo a aquellos determinados en
                        el apartado v y vi de este tratamiento. Utilizamos las medidas técnicas y
                        organizativas adecuadas, con la finalidad de proteger su información
                        personal y su privacidad, y revisamos dichas medidas periódicamente para
                        evitar la pérdida o el mal uso de los datos que almacenamos. Protegemos su
                        información personal mediante el uso de una combinación de controles de
                        seguridad tanto físicos como informáticos o lógicos, incluso controles de
                        acceso que restringen y administran la forma en que su información personal
                        y sus datos personales son procesados, administrados y gestionados. También
                        nos aseguramos de que nuestros empleados se encuentren debidamente
                        capacitados para proteger su información personal, no usando la información
                        a la que tenga acceso por razón de su trabajo para fines diferentes a los
                        inherentes al desarrollo de su actividad profesional.
                    </p>
                    <p>
                        IX. Derechos de los interesados
                    </p>
                    <p>
                        Cualquier persona tiene derecho a obtener información y confirmación sobre
                        los tratamientos que de sus datos se llevan a cabo por SOLUNION.
                    </p>
                    <p>
                        Puede ejercer sus derechos de acceso, rectificación, supresión (derecho al
                        olvido) y portabilidad de sus datos, de limitación y oposición a su
                        tratamiento, así como a no ser objeto de decisiones basadas únicamente en
                        el tratamiento automatizado de sus datos, cuando procedan, ante la
                        dirección social de SOLUNION en Avenida General Perón, n.º 40, 28020 Madrid
                        o mediante correo electrónico dirigiéndose a la dirección
                        <a className="text-start ms-2" href="mailto:proteccion.dedatos.es@solunion.com">
                            proteccion.dedatos.es@solunion.com
                        </a>
                    </p>
                    <p>
                        En dicha comunicación, deberá incluir una copia de su documento nacional de
                        identidad o cualquier documento equivalente que acredite su identidad.
                    </p>
                    <p>
                        Le informamos que puede presentar una reclamación ante la Agencia Española
                        de Protección de Datos, especialmente cuando considere que no ha obtenido
                        satisfacción en el ejercicio de sus derechos, a través de la página web
                        habilitada a tales efectos por la Autoridad de Control correspondiente
                        <a target="_blank" rel="noreferrer" className="text-start ms-2" href="https://www.aepd.es/">www.aepd.es</a>
                    </p>
                    <p>
                        Se entiende que usted queda informado y acepta las condiciones establecidas
                        anteriormente si continúa navegando en el sitio web, en su caso, si pulsa
                        el botón ENVIAR/CONTINUAR/ACEPTAR que se encuentra en los formularios de
                        recogida de datos.
                    </p>

                </div>

            </div>


        </div>

    )
}